import { authHeader } from "../components/auth/Signin";
import { navigator } from "../components/Home/Home";


function Certificate_Back() {
  fetch(window.config.backend.http_route, {
    method: 'GET',
    headers: authHeader(),
  })
    .catch(error => { console.log("Certificate Backend:", error); window.location.href = "/ow/view/certs/backend"; })
}

function getBackendRoute(protocol) {
  switch (protocol) {
    case "HTTP":
    default:
      return window.config.backend.eac_route/*.replace(
        "127.0.0.1",
        window.location.hostname
      )*/;
  }
}

export function EacAuthenticatedGetFetch(url, callback, redirect = null, signal, errCallback, isNotJson) {
  fetch(getBackendRoute('HTTP') + url, {
    signal: signal,
    method: 'GET',
    headers: authHeader()
  })
    .then((response) => {
      const statusCode = response.status;
      if (statusCode === 401) { // (Unauthorized)
        if (localStorage.getItem('token') != null)
          localStorage.clear();
        window.location.reload(false);

        if (redirect !== null)
          redirect.push('Signin');
      }
      let data;
      try {
        if(isNotJson)
          data = response.arrayBuffer();
        else
          data = response.json();
        return Promise.all([statusCode, data]);
      } catch (e) {
        return Promise.all([statusCode, {}]);
      }
    })
    .then((res) => {
      const data = res[1]
      if (res[0] < 400) {
        callback(data);
      }
      else {
        console.error(`error [${res[0]}] in the result of ${url}`);
        if (errCallback !== undefined)
          errCallback();
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        console.error(`error [${error}] in the result of ${url}`);
        if (errCallback !== undefined)
          errCallback();
      }
    });
}

export function EacAuthenticatedGetFetchWithoutLoginRedirection(url, callback, signal, errCallback) {
  fetch(getBackendRoute('HTTP')  + url, {
    signal: signal,
    method: 'GET',
    headers: authHeader()
  })
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then((res) => {
      const data = res[1]
      if (res[0] < 400) // OK
        callback(data);
      else {
        console.error("status [" + res[0] + "] in the result of " + url);
        if (errCallback !== undefined)
          errCallback();
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        console.error("error [", error, "] in the result of " + url);
        if (errCallback !== undefined)
          errCallback();
      }
    });
}


export function EacAuthenticatedGetFetchBlob(url, callback, errCallback) {
  try {
    fetch(getBackendRoute('HTTP')  + url, {
      method: 'GET',
      headers: authHeader()
    })
      .then((response) => {
        if (!response.ok) {
          if (errCallback !== undefined)
            errCallback();
        }
        else
          return response.blob();
      })
      .then(blob => {
        if (blob !== undefined)
          callback(URL.createObjectURL(blob));
      })
      .catch(error => {
        if (error.name === "AbortError") return;
        else {
          console.error(error);
          if (errCallback !== undefined)
            errCallback()
        }
      })
  } catch (error) {
    if (error.name === "AbortError") return;
    else {
      console.error(error);
      if (errCallback !== undefined)
        errCallback()
    }
    //do nothing (bad token ? not a blob ?)

  }
}

// send a post and callback with the value of the status code (200 = OK, 401 = invalid token -> redirect to signin)
export function EacAuthenticatedPostFetch(url, data, callback, errorCallback) {
  fetch(getBackendRoute('HTTP')  + url,
    {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
      },
      body: JSON.stringify(data)
    })
    .then((response) => {
      const statusCode = response.status;
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res !== 401) // (Unauthorized)
      {
        if (res >= 400 && typeof errorCallback === "function") {
          errorCallback();
        }
        else if (typeof callback === "function") {
          callback(res);
        }
      }
      else {
        localStorage.clear();
        navigator.push('Signin', { error: 'session over' });
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        console.error(error);
        if (errorCallback !== undefined)
          errorCallback();
      }

    });
}

export function EacAuthenticatedPostFile(url, data, callback, errorCallback) {
  const formData = new FormData();
  formData.append('logo', data);
  fetch(getBackendRoute('HTTP')  + url,
    {
      method: 'POST',
      headers: {
        /* 'Content-Type': "multipart/form-data", */
        'Authorization': authHeader().Authorization
      },
      body: formData
    })
    .then((response) => {
      const statusCode = response.status;
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res.status !== 401) // (Unauthorized)
        callback(res);
      else {
        localStorage.clear();
        navigator.push('Signin', { error: 'session over' });
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        console.error("[" + url + "] error: ", error);
        if (errorCallback !== undefined)
          errorCallback();
      }
    });
}

export function EacAuthenticatedPostFetchWithResult(url, data, callback, errorCallback, isNotJSON) {
  fetch(getBackendRoute('HTTP')  + url,
    {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
      },
      body: JSON.stringify(data)
    })
    .then((response) => {
      const statusCode = response.status;

      return Promise.all([statusCode, isNotJSON ? response.text() : response.json()]);
    })
    .then((res) => {
      if (res[0] === 401) // (Unauthorized)
      {
        localStorage.clear();
        navigator.push('Signin', { error: 'session over' });
      } else {
        if (res[0] >= 400 && typeof errorCallback === "function")
          errorCallback(res[1]);
        else
          callback(res[0], res[1]);
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        Certificate_Back()
        console.error("[" + url + "] error: ", error);
        if (errorCallback !== undefined)
          errorCallback();
      }
    });
}

export function EacAuthenticatedPutFetch(url, data, callback, errorCallback) {
  fetch(getBackendRoute('HTTP')  + url,
    {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
      },
      body: JSON.stringify(data)
    })
    .then((response) => {
      const statusCode = response.status;
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res !== 401) { // (Unauthorized)
        if (res >= 400 && typeof errorCallback === "function") {
          errorCallback();
        }
        else if (typeof callback === "function") {
          callback(res);
        }
      }
      else {
        localStorage.clear();
        navigator.push('Signin', { error: 'session over' });
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        console.error(error);
        if (errorCallback !== undefined)
          errorCallback();
      }

    });
}

export function EacAuthenticatedDeleteFetch(url, data, callback, errorCallback) {
  fetch(getBackendRoute('HTTP')  + url,
    {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
      },
      body: JSON.stringify(data)
    })
    .then((response) => {
      const statusCode = response.status;
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res !== 401) { // (Unauthorized)
        if (res >= 400 && typeof errorCallback === "function") {
          errorCallback();
        }
        else if (typeof callback === "function") {
          callback(res);
        }
      }
      else {
        localStorage.clear();
        navigator.push('Signin', { error: 'session over' });
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        console.error(error);
      }
    });
}


export function EacAuthenticatedPatchFetch(url, data, callback, errorCallback) {
  fetch(getBackendRoute('HTTP')  + url,
    {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
      },
      body: JSON.stringify(data)
    })
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then((res) => {
      if (res[0] === 401) // (Unauthorized)
      {
        localStorage.clear();
        navigator.push('Signin', { error: 'session over' });
      } else {
        if (res[0] >= 400 && typeof errorCallback === "function")
          errorCallback(res[1]);
        else
          callback(res[0], res[1]);
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        Certificate_Back()
        console.error("[" + url + "] error: ", error);
        if (errorCallback !== undefined)
          errorCallback();
      }
    });
}
